import React from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import {motion} from 'framer-motion';
import SEOHead from './components/SEOHead';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import BenefitsSection from './components/BenefitsSection';
import TransitionSection from './components/TransitionSection';
import LexwareAdvantagesSection from './components/LexwareAdvantagesSection';
import PricingSection from './components/PricingSection';
import PersonalNoteSection from './components/PersonalNoteSection';
import ContactSection from './components/ContactSection';
// Unterseiten
import BlogPage from './pages/BlogPage';
import IntegrationsPage from './pages/IntegrationsPage';
import AboutPage from './pages/AboutPage';
import Navigation from './components/Navigation';
import NewsletterSubscription from './components/NewsletterSubscription';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import Impressum from './components/Impressum';
import QuestOnboarding from './components/QuestOnboarding';
import './App.css';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const {FiBook,FiLink,FiUsers}=FiIcons;
function HomePage() {
  return (
    <>
      <SEOHead />
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.5}}>
        <HeroSection />
        <IntroSection />
        <BenefitsSection />
        <TransitionSection />
        <LexwareAdvantagesSection />
        <PricingSection />
        <PersonalNoteSection />
        <ContactSection />
        {/* Links zu Unterseiten */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6"> Wenn du vorab mehr wissen möchtest </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto"> Hier findest du zusätzliche Informationen – je nachdem,was du gerade brauchst. </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
              <motion.a href="#/ueber-mich" whileHover={{scale: 1.05}} className="bg-[#F3F1EE] p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center" >
                <div className="flex justify-center mb-4">
                  <SafeIcon icon={FiUsers} className="text-[#E30613] text-2xl" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Über mich</h3>
                <p className="text-gray-600 text-sm">Wer ich bin,wie ich arbeite und warum ich diese Arbeit mache.</p>
              </motion.a>
              <motion.a href="#/lexware-abc" whileHover={{scale: 1.05}} className="bg-[#F3F1EE] p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center" >
                <div className="flex justify-center mb-4">
                  <SafeIcon icon={FiBook} className="text-[#E30613] text-2xl" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">Lexware ABC</h3>
                <p className="text-gray-600 text-sm">Kurzer Überblick über Funktionen und Begriffe – verständlich erklärt.</p>
              </motion.a>
              <motion.a href="#/integrationen" whileHover={{scale: 1.05}} className="bg-[#F3F1EE] p-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-center" >
                <div className="flex justify-center mb-4">
                  <SafeIcon icon={FiLink} className="text-[#E30613] text-2xl" />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">140+ Integrationen</h3>
                <p className="text-gray-600 text-sm">Welche Möglichkeiten du später nutzen kannst,um Abläufe weiter zu automatisieren.</p>
              </motion.a>
            </div>
            <div className="text-center mt-8">
              <p className="text-xl text-gray-600 max-w-3xl mx-auto"> 
                Du hast noch Fragen oder möchtest einfach kurz Hallo sagen?<br />
                Schreib mir gern – ich freue mich auf deine Nachricht.
              </p>
            </div>
          </div>
        </section>
      </motion.div>
    </>
  );
}
function App() {
  // Initialize Quest Onboarding
  QuestOnboarding();
  return (
    <div className="min-h-screen bg-white">
      <Router>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/lexware-abc" element={<BlogPage />} />
          <Route path="/integrationen" element={<IntegrationsPage />} />
          <Route path="/ueber-mich" element={<AboutPage />} />
          <Route path="/datenschutz" element={<PrivacyPolicy />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
        {/* Footer auf allen Seiten anzeigen */}
        <Footer />
      </Router>
    </div>
  );
}
export default App;